import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import type * as Highcharts from 'highcharts';
import type { BeniBreakdown } from 'lumen/models';
import type { BreakdownPeriodType } from 'lumen/models/benchmark-insight/breakdown';

export const HERO_CHART_SERIES_IDS = {
  OWN: 'own',
  OWN_REFERENCE: 'ownReference',
  PRIMARY_COMPARISON_SET: 'primaryComparisonSet',
  PRIMARY_COMPARISON_SET_REFERENCE: 'primaryComparisonSetReference',
  SECONDARY_COMPARISON_SET: 'secondaryComparisonSet',
  SECONDARY_COMPARISON_SET_REFERENCE: 'secondaryComparisonSetReference',
  KPI_DIFF_VS_COMPARISON_SET: 'kpiDiffVsComparisonSet',
  INDEX: 'index',
} as const;
export type HeroChartSeriesId =
  (typeof HERO_CHART_SERIES_IDS)[keyof typeof HERO_CHART_SERIES_IDS];

export interface HeroChartSeriesPoint {
  segmentation?: BeniBreakdown;
  showWarningForWeek?: boolean;
  x: number;
  y: number | null;
}

export interface HeroChartKpiDiffVsComparisonSetSeriesPoint {
  high: number | null;
  low: number | null;
  segmentation?: BeniBreakdown;
  showWarningForWeek?: boolean;
  x: number;
}

export interface HeroChartSeries extends Highcharts.SeriesOptions {
  breakdownPeriodType?: BreakdownPeriodType;
  color: Highcharts.ColorString | Highcharts.GradientColorObject;
  comparisonSetType?: ComparisonSet;
  data: (HeroChartSeriesPoint | HeroChartKpiDiffVsComparisonSetSeriesPoint)[];
  hasReferencePeriodData?: boolean;
  id?: HeroChartSeriesId;
  lineWidth?: number;
  name: string;
  negativeColor?: string;
  pointPadding?: number;
  threshold?: number;
  type: string;
  visible: boolean;
  xAxis?: number;
  yAxis?: number;
  zIndex: number;
  zoneAxis?: string;
  zones?: Highcharts.SeriesZonesOptionsObject[];
}
